import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";
import { $element } from "@grindex-common/helpers/elements";

const SELECTOR_PROMPTMESSAGE = ".prompt-message";
const SELECTOR_NAVIGATION = "nav.c-nav__navigation";
const ELEMENT_REJECT_BUTTON = "country-prompt-reject";
const ELEMENT_ACCEPT_BUTTON = "country-prompt-accept";
const CLASS_FULLWIDTH = "full-width";
const CLASS_MESSAGE_CLOSED = "js-message-closed";
const JS_CLASS_MESSAGE_OPENED = "js-message-opened";
const CLASS_MESSAGE_OPENED = "message-opened";
const CLASS_INIT = "init";

export default class CountryPromptDom extends DomElementsBase {
	constructor($module) {
		const selectors = [SELECTOR_NAVIGATION, SELECTOR_PROMPTMESSAGE, ELEMENT_REJECT_BUTTON, ELEMENT_ACCEPT_BUTTON];

		super($module, selectors);

		this.$rejectButton = $element(ELEMENT_REJECT_BUTTON);
		this.$acceptButton = $element(ELEMENT_ACCEPT_BUTTON);
	}

	navigationElement() {
		return this.getElements(SELECTOR_NAVIGATION);
	}

	acceptButtonElement() {
		return this.$acceptButton;
	}

	rejectButtonElement() {
		return this.$rejectButton;
	}

	resetNavigationMargin() {
		this.navigationElement().marginTop = "";
	}

	removeFullWidth() {
		document.documentElement.classList.remove(CLASS_FULLWIDTH);
		document.body.classList.remove(CLASS_FULLWIDTH);
	}

	addFullWidth() {
		document.documentElement.classList.add(CLASS_FULLWIDTH);
		document.body.classList.add(CLASS_FULLWIDTH);
	}

	setPromptClosed() {
		const $module = super.getModuleElement();

		$module.classList.add(CLASS_MESSAGE_CLOSED);
		$module.classList.remove(JS_CLASS_MESSAGE_OPENED);
		$module.classList.remove(CLASS_MESSAGE_OPENED);
		$module.setAttribute("style", "display: none");

		var timeout = setTimeout(() => {
			$module.classList.remove(CLASS_INIT);
			clearTimeout(timeout);
		}, 1000);
	}

	setPromptOpened() {
		const $module = super.getModuleElement();

		$module.classList.add(CLASS_INIT);
		$module.setAttribute("style", "display: block");

		var timeout = setTimeout(() => {
			$module.classList.add(JS_CLASS_MESSAGE_OPENED);
			$module.classList.add(CLASS_MESSAGE_OPENED);

			clearTimeout(timeout);
		}, 750);
	}
}
